import React from 'react';

const MoveDown = () => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2505 0.5L0.250492 0.5C0.0335504 0.5 -0.0804297 0.757382 0.0653734 0.918021L5.51123 6.91802C5.60978 7.0266 5.78019 7.02744 5.87981 6.91983L11.434 0.919829C11.5821 0.759772 11.4686 0.5 11.2505 0.5Z"
      fill="var(--SECONDARY_DARK)"
    />
  </svg>
);

export default MoveDown;
